import { apiCall } from './gqlClient';
const GETPAYMENTOPTIONS_QUERY = "\n  query getPaymentOptions($providerId: Int) {\n    getPaymentOptions(providerId: $providerId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceOnsite\n\t\t\tserviceOnline\n\t\t\tserviceMembership\n\t\t\tcourseOnsite\n\t\t\tcourseOnline\n\t\t\tcourseMembership\n\t\t\tmembershipOnsite\n\t\t\tmembershipOnline\n\t\t\tonlineDiscount\n\t\t\tacceptNonCustomerBookings\n      ...fragments\n    }\n  }";
export const getPaymentOptionsApiCall = async function (_ref) {
  let {
    providerId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPAYMENTOPTIONS_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const SHOWPAYMENTBUTTONSCUSTOMER_QUERY = "\n  query showPaymentButtonsCustomer($providerId: Int!, $serviceId: Int, $reservationDate: DateTime, $sessions: [Int], $membershipId: Int) {\n    showPaymentButtonsCustomer(providerId: $providerId, serviceId: $serviceId, reservationDate: $reservationDate, sessions: $sessions, membershipId: $membershipId)\n    {\n      payOnsite\n\t\t\tpayOnline\n\t\t\tpayWithMembership\n      ...fragments\n    }\n  }";
export const showPaymentButtonsCustomerApiCall = async function (_ref2) {
  let {
    providerId,
    serviceId,
    reservationDate,
    sessions,
    membershipId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SHOWPAYMENTBUTTONSCUSTOMER_QUERY,
    variables: {
      providerId,
      serviceId,
      reservationDate,
      sessions,
      membershipId
    },
    fragments
  });
};
const SHOWPAYMENTBUTTONSPROVIDER_QUERY = "\n  query showPaymentButtonsProvider($serviceId: Int, $membershipId: Int, $userId: Int, $customerId: Int, $reservationDate: DateTime, $sessions: [Int]) {\n    showPaymentButtonsProvider(serviceId: $serviceId, membershipId: $membershipId, userId: $userId, customerId: $customerId, reservationDate: $reservationDate, sessions: $sessions)\n    {\n      payOnsite\n\t\t\tpayOnline\n\t\t\tpayWithMembership\n      ...fragments\n    }\n  }";
export const showPaymentButtonsProviderApiCall = async function (_ref3) {
  let {
    serviceId,
    membershipId,
    userId,
    customerId,
    reservationDate,
    sessions
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SHOWPAYMENTBUTTONSPROVIDER_QUERY,
    variables: {
      serviceId,
      membershipId,
      userId,
      customerId,
      reservationDate,
      sessions
    },
    fragments
  });
};
const UPDATEPAYMENTOPTIONS_QUERY = "\n  mutation updatePaymentOptions($request: PaymentOptionsInput!) {\n    updatePaymentOptions(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updatePaymentOptionsApiCall = async function (_ref4) {
  let {
    request
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEPAYMENTOPTIONS_QUERY,
    variables: {
      request
    },
    fragments
  });
};